import FooterStateful from "../../footerstateful/FooterStateful";
import React from "react";
import { decodeComponentString } from "@microsoft/omnichannel-chat-components";
import { shouldShowFooter } from "../../../controller/componentController";
export const createFooter = (props, state) => {
  var _props$controlProps, _props$componentOverr;
  const hideFooterDisplay = !((_props$controlProps = props.controlProps) !== null && _props$controlProps !== void 0 && _props$controlProps.hideFooter) && shouldShowFooter(state) ? false : true;
  const footer = decodeComponentString((_props$componentOverr = props.componentOverrides) === null || _props$componentOverr === void 0 ? void 0 : _props$componentOverr.footer) || /*#__PURE__*/React.createElement(FooterStateful, {
    footerProps: props.footerProps,
    downloadTranscriptProps: props.downloadTranscriptProps,
    audioNotificationProps: props.audioNotificationProps,
    hideFooterDisplay: hideFooterDisplay
  });
  return footer;
};